import type { PressEvent } from '@react-types/shared';
import { ChatIcon } from 'components/common/Icons';
import { WaitlistStatus } from 'utils/constants/Chat';

import { CSS } from '@project44/manifest-ds';
import { Banner } from '@project44/shared-components';
import { useTranslation } from '@project44/translations-utils';

interface Props {
  status: WaitlistStatus;
  onJoin: (event: PressEvent) => void;
  onClose: (event: PressEvent) => void;
  css?: CSS;
}

export default function ChatWaitlistBanner({
  status,
  onJoin,
  onClose,
  css,
}: Props): JSX.Element | null {
  const { t } = useTranslation();
  let bannerProps;

  switch (status) {
    case WaitlistStatus.PENDING_JOIN:
      bannerProps = {
        title: t('core.chat.introducing'),
        subTitle: t('core.chat.genAI'),
        buttonText: t('core.chat.join'),
        buttonProps: {
          onPress: onJoin,
        },
      };
      break;
    case WaitlistStatus.PENDING_GRANTED:
      bannerProps = {
        title: t('core.chat.onWaitlist'),
        subTitle: t('core.chat.receiveEmail'),
      };
      break;
    default:
      return null;
  }

  return (
    <Banner
      {...bannerProps}
      icon={() => <ChatIcon />}
      onClose={onClose}
      titleCSS={{
        flex: 1,
      }}
      css={{
        backgroundColor: '$palette-purple-50',
        ...css,
      }}
    />
  );
}
